export default interface User {
  id: number;
  name: string;
}

export const userDefaultProps: User = {
  id: 0,
  name: "-",
};
